import { render, staticRenderFns } from "./ideologicalAccess.vue?vue&type=template&id=1e0fa2c3&scoped=true"
import script from "./ideologicalAccess.vue?vue&type=script&lang=js"
export * from "./ideologicalAccess.vue?vue&type=script&lang=js"
import style0 from "./ideologicalAccess.vue?vue&type=style&index=0&id=1e0fa2c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0fa2c3",
  null
  
)

export default component.exports